import {getData} from '../stores/util'
import {alert} from '../stores/global'

export const Tool = {};


Tool.alert = (msg, msg2, cb) => {
    if (msg2 === undefined || typeof msg2 === 'function') {
        if (!cb) cb = msg2;
        msg2 = msg;
        msg = ''
    }
    if(!msg&&!msg2)return;
    alert.show({
        title: msg,
        msg: msg2,
        justSure: 1,
        sureHandle: cb || (() => 0)
    })
};

Tool.fetch = obj => {
    let sendData = obj.sendData;
    getData(obj.url, sendData,
        data => {
            obj.success(data)
        },
        err => obj.error(err),
        obj.method || 'POST')
};
